var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillInferenceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.351,
    height: 36.332,
    viewBox: "0 0 38.351 36.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.5,439.421H280.278a1.866,1.866,0,0,1-1.864-1.864V435.58h1.5v1.976a.364.364,0,0,0,.364.364H297.5a.365.365,0,0,0,.365-.364v-9.579a.365.365,0,0,0-.365-.365H280.278a.365.365,0,0,0-.364.365v2.232h-1.5v-2.232a1.866,1.866,0,0,1,1.864-1.865H297.5a1.867,1.867,0,0,1,1.865,1.865v9.579A1.866,1.866,0,0,1,297.5,439.421Z",
    transform: "translate(-261.761 -414.189)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.709,9.891-.709,9.4,2.62-.245,4.038.245Z",
    transform: "translate(19.11 24.655)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62,9.891-.709.245.709-.245,4.038,9.4Z",
    transform: "translate(30.223 24.655)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.892.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H3.892a.75.75,0,0,1,.75.75A.75.75,0,0,1,3.892.75Z",
    transform: "translate(24.129 17.096)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.969.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H4.969a.75.75,0,0,1,.75.75A.75.75,0,0,1,4.969.75Z",
    transform: "translate(24.129 19.963)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.215,418.756a4.2,4.2,0,0,1-4.169-4.03V413.6a4.117,4.117,0,0,1,4.169-4.054,4.2,4.2,0,0,1,2.926,1.188,3.964,3.964,0,0,1,1.243,2.865v1.1A4.117,4.117,0,0,1,265.215,418.756Zm-2.669-4.066a2.686,2.686,0,0,0,2.669,2.566,2.616,2.616,0,0,0,2.669-2.554v-1.1a2.648,2.648,0,0,0-2.669-2.554,2.616,2.616,0,0,0-2.669,2.554Z",
    transform: "translate(-257.681 -410.298)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.816,448.94h-9.672v-11.5a4.69,4.69,0,0,1-2.107-1.243,4.089,4.089,0,0,1-1.37-2.782v-5.389a5.276,5.276,0,0,1,1.821-3.949,5.715,5.715,0,0,1,3.682-1.5h5.447c3.206,0,4.911,2.505,5.929,4,.148.218.288.423.412.591.979,1.325,3.774,5.294,3.893,5.462l.364.516-1.258,1.257a2.673,2.673,0,0,1-3.781,0l-3.36-3.275Zm-8.172-1.5h6.672V427.576l5.917,5.768a1.173,1.173,0,0,0,1.663,0l.365-.365c-.81-1.147-2.748-3.888-3.509-4.919-.141-.191-.289-.408-.445-.638-.961-1.412-2.277-3.346-4.689-3.346H261.17a4.181,4.181,0,0,0-2.68,1.112,3.8,3.8,0,0,0-1.323,2.832v5.389a3.4,3.4,0,0,0,1.977,2.446v-7.836a.75.75,0,0,1,1.5,0Z",
    transform: "translate(-256.417 -413.359)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.167a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V11.417A.75.75,0,0,1,0,12.167Z",
    transform: "translate(7.534 23.414)",
    fill: "#6b19ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillInferenceIcon);
export default __webpack_public_path__ + "static/media/skill-inference-icon.c47064138348bf02594b30b85114f1dc.svg";
export { ForwardRef as ReactComponent };